<template>
    <div class="project-cover">
        <img src="../../../assets/img/projects/mangasky-theme.png" />
    </div>
    <div class="about">
        <h1 class="title">mangaSKY Theme</h1>
        <p class="text">Tema de website desenvolvido para sites de leitura de quadrinhos online.</p>
        <ul class="languages">
            <li class="language-box">
                <img src="../../../assets/img/languages/html.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/css.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/sass.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/js.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/jquery.svg" class="language" />
            </li>
        </ul>
        <a
            href="https://github.com/eubrunocoelho/mangaSKY-theme"
            class="show-more"
            target="_blank"
            rel="noopener noreferrer"
        >
            Exibir mais
        </a>
    </div>
</template>

<script>
export default {
    name: 'ProjectMangasSKYTheme',
};
</script>
